import TooltipModal from './Tooltip'

export default TooltipModal
